module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_reason01-c77a8ba5106852d637c3e62bb33c1cce.png";